import { render, staticRenderFns } from "./ManagementIndex.vue?vue&type=template&id=5284e0de&scoped=true&"
import script from "./ManagementIndex.vue?vue&type=script&lang=js&"
export * from "./ManagementIndex.vue?vue&type=script&lang=js&"
import style0 from "./ManagementIndex.vue?vue&type=style&index=0&id=5284e0de&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5284e0de",
  null
  
)

export default component.exports